enum RefundPaymentType {
  cheque = 'Cheque',
  ETransfer = 'E-Transfer',
  eft = 'EFT',
}

export default RefundPaymentType;
export type VerifyRefundPaymentType = Utils.VerifyExtends<
  Model.Enum.RefundPaymentType,
  Utils.ValueOf<typeof RefundPaymentType>
>;
